import Slide1 from "../assets/slide1.png";
import Slide2 from "../assets/slide2.png";
import Slide3 from "../assets/slide3.png";
import Slide4 from "../assets/slide4.png";
import Slide5 from "../assets/slide5.png";
import Slide6 from "../assets/slide6.png";
import Slide7 from "../assets/slide7.png";
import Slide8 from "../assets/slide8.png";
import Slide9 from "../assets/slide9.png";
import Slide10 from "../assets/slide10.png";
import Slide11 from "../assets/slide11.png";
import Slide12 from "../assets/slide12.png";
import Slide13 from "../assets/slide13.png";
import Slide14 from "../assets/slide14.png";
import Slide15 from "../assets/slide15.png";
import Slide16 from "../assets/slide16.png";
import Slide17 from "../assets/slide17.png";
import Slide18 from "../assets/slide18.png";
import Slide19 from "../assets/slide19.png";
import Slide20 from "../assets/slide20.png";
import Slide21 from "../assets/slide21.png";
import Slide22 from "../assets/slide22.png";
import Slide23 from "../assets/slide23.png";
import Slide24 from "../assets/slide24.png";
import Slide25 from "../assets/slide25.png";
import Slide26 from "../assets/slide26.png";
import Slide27 from "../assets/slide27.png";
import Slide28 from "../assets/slide28.png";
import Slide29 from "../assets/slide29.png";
import Slide30 from "../assets/slide30.png";
import Slide31 from "../assets/slide31.png";
import Slide32 from "../assets/slide32.png";
import Slide33 from "../assets/slide33.png";
import Slide34 from "../assets/slide34.png";
import Slide35 from "../assets/slide35.png";
import Slide36 from "../assets/slide36.png";
// import Slide37 from "../assets/slide37.png";
// import Slide38 from "../assets/slide38.png";
// import Slide39 from "../assets/slide39.png";
// import Slide40 from "../assets/slide40.png";
// import Slide41 from "../assets/slide41.png";
// import Slide42 from "../assets/slide42.png";
// import Slide43 from "../assets/slide43.png";
// import Slide44 from "../assets/slide44.png";
// import Slide45 from "../assets/slide45.png";
// import Slide46 from "../assets/slide46.png";
// import Slide47 from "../assets/slide47.png";
// import Slide48 from "../assets/slide48.png";
// import Slide49 from "../assets/slide49.png";
// import Slide50 from "../assets/slide50.png";
// import Slide51 from "../assets/slide51.png";
// import Slide52 from "../assets/slide52.png";
// import Slide53 from "../assets/slide53.png";
// import Slide54 from "../assets/slide54.png";
// import Slide55 from "../assets/slide55.png";

export const imageArray = [
  { id: 1, src: Slide1 },
  { id: 2, src: Slide2 },
  { id: 3, src: Slide3 },
  { id: 4, src: Slide4 },
  { id: 5, src: Slide5 },
  { id: 6, src: Slide6 },
  { id: 7, src: Slide7 },
  { id: 8, src: Slide8 },
  { id: 9, src: Slide9 },
  { id: 10, src: Slide10 },
  { id: 11, src: Slide11 },
  { id: 12, src: Slide12 },
  { id: 13, src: Slide13 },
  { id: 14, src: Slide14 },
  { id: 15, src: Slide15 },
  { id: 16, src: Slide16 },
  { id: 17, src: Slide17 },
  { id: 18, src: Slide18 },
  { id: 19, src: Slide19 },
  { id: 20, src: Slide20 },
  { id: 21, src: Slide21 },
  { id: 22, src: Slide22 },
  { id: 23, src: Slide23 },
  { id: 24, src: Slide24 },
  { id: 25, src: Slide25 },
  { id: 26, src: Slide26 },
  { id: 27, src: Slide27 },
  { id: 28, src: Slide28 },
  { id: 29, src: Slide29 },
  { id: 30, src: Slide30 },
  { id: 31, src: Slide31 },
  { id: 32, src: Slide32 },
  { id: 33, src: Slide33 },
  { id: 34, src: Slide34 },
  { id: 35, src: Slide35 },
  { id: 36, src: Slide36 },
  // { id: 37, src: Slide37 },
  // { id: 38, src: Slide38 },
  // { id: 39, src: Slide39 },
  // { id: 40, src: Slide40 },
  // { id: 41, src: Slide41 },
  // { id: 42, src: Slide42 },
  // { id: 43, src: Slide43 },
  // { id: 44, src: Slide44 },
  // { id: 45, src: Slide45 },
  // { id: 46, src: Slide46 },
  // { id: 47, src: Slide47 },
  // { id: 48, src: Slide48 },
  // { id: 49, src: Slide49 },
  // { id: 50, src: Slide50 },
  // { id: 51, src: Slide51 },
  // { id: 52, src: Slide52 },
  // { id: 53, src: Slide53 },
  // { id: 54, src: Slide54 },
  // { id: 55, src: Slide55 },
];
